/* =============================================================
   YARD REMEDY - Site-Wide Animations & Interactions
   Jamaica Herbal Theme
   ============================================================= */

(function() {
  'use strict';

  /* ===== SCROLL-TRIGGERED ANIMATIONS (IntersectionObserver) ===== */
  function initScrollAnimations() {
    var animatedElements = document.querySelectorAll(
      '.yr-animate-fade-in, .yr-animate-fade-left, .yr-animate-fade-right, .yr-animate-scale-in'
    );

    if (!animatedElements.length) return;

    // Respect reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      animatedElements.forEach(function(el) {
        el.classList.add('yr-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('yr-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    animatedElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ===== AUTO-DETECT SECTIONS FOR SCROLL ANIMATION ===== */
  function autoAnimateSections() {
    // Automatically apply fade-in-up animation to major sections
    var sections = document.querySelectorAll(
      '.shopify-section:not(.shopify-section-header):not(.shopify-section-footer), ' +
      '.yr-section, ' +
      '.section'
    );

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.classList.contains('yr-auto-revealed')) {
          entry.target.classList.add('yr-auto-revealed');
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -30px 0px'
    });

    sections.forEach(function(section) {
      // Skip if already has explicit animation class
      if (section.classList.contains('yr-animate-fade-in') ||
          section.classList.contains('yr-animate-fade-left') ||
          section.classList.contains('yr-animate-fade-right')) {
        return;
      }

      // Always skip sections already in the viewport — never hide above-the-fold content
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        return;
      }

      // Skip main template sections (collection, product, cart, account, etc.) — they must be visible immediately
      if (section.querySelector('.yr-collection-banner') ||
          section.querySelector('.yr-product-grid-section') ||
          section.querySelector('[id="product-grid"]') ||
          section.querySelector('[id="MainProduct"]') ||
          section.querySelector('.yr-breadcrumb') ||
          section.querySelector('.yr-account') ||
          section.querySelector('.customer')) {
        return;
      }

      // Apply initial hidden state only to below-the-fold sections
      section.style.opacity = '0';
      section.style.transform = 'translateY(20px)';
      section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(section);
    });
  }

  /* ===== SUBTLE PARALLAX ON HERO IMAGES ===== */
  function initParallax() {
    var parallaxElements = document.querySelectorAll('.yr-parallax img, .yr-parallax__bg, .banner__media img');

    if (!parallaxElements.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;
      parallaxElements.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        var elementTop = rect.top + scrollY;
        var viewportHeight = window.innerHeight;

        // Only apply when element is in viewport
        if (rect.top < viewportHeight && rect.bottom > 0) {
          var parallaxOffset = (scrollY - elementTop) * 0.12;
          parallaxOffset = Math.max(-50, Math.min(50, parallaxOffset));
          el.style.transform = 'translateY(' + parallaxOffset + 'px) scale(1.05)';
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ===== COUNTER / NUMBER ANIMATION ===== */
  function initCounters() {
    var counters = document.querySelectorAll('.yr-counter[data-target]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(counter) {
      observer.observe(counter);
    });
  }

  function animateCounter(element) {
    var target = parseInt(element.getAttribute('data-target'), 10);
    var duration = parseInt(element.getAttribute('data-duration') || '1500', 10);
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease out quad
      var eased = 1 - (1 - progress) * (1 - progress);
      var current = Math.floor(eased * target);
      element.textContent = current.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = target.toLocaleString();
      }
    }

    requestAnimationFrame(step);
  }

  /* ===== IMAGE LAZY LOAD SHIMMER ===== */
  function initImageShimmer() {
    var images = document.querySelectorAll('.card__media img[loading="lazy"]');
    images.forEach(function(img) {
      if (img.complete) return;
      var media = img.closest('.media');
      if (media) {
        media.classList.add('yr-shimmer-active');
        img.addEventListener('load', function() {
          media.classList.remove('yr-shimmer-active');
        }, { once: true });
      }
    });
  }

  /* ===== INITIALIZE EVERYTHING ===== */
  function init() {
    initScrollAnimations();
    autoAnimateSections();
    initParallax();
    initCounters();
    initImageShimmer();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

})();
